import { render, staticRenderFns } from "./DefaultFormValidationProvider.vue?vue&type=template&id=3b85a8fd"
import script from "./DefaultFormValidationProvider.vue?vue&type=script&lang=js"
export * from "./DefaultFormValidationProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports